import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import EarlyAccessContext from '../context/EarlyAccessContext';

const Nav = () => {
  const { setIsOpen } = useContext(EarlyAccessContext);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const handleJoinEarlyAccess = () => {
    setIsOpen(true);
    closeMobileMenu();
  };

  return (
    <nav className="nav">
      <Link to="/" className="brand" onClick={closeMobileMenu}>
        <span className="brand__word brand__word--sprout">Sprout</span>
        <span className="brand__word brand__word--academy">Academy</span>
      </Link>

      <button
        className="nav__toggle"
        type="button"
        aria-label="Toggle navigation"
        aria-expanded={isMobileMenuOpen}
        onClick={() => setIsMobileMenuOpen((value) => !value)}
      >
        <span className="nav__toggle-line" />
        <span className="nav__toggle-line" />
        <span className="nav__toggle-line" />
      </button>

      <div className={`nav__menu ${isMobileMenuOpen ? 'nav__menu--open' : ''}`}>
        <div className="nav__links">
          <Link to="/" onClick={closeMobileMenu}>Home</Link>
          <Link to="/about" onClick={closeMobileMenu}>About us</Link>
          <Link to="/curriculum" onClick={closeMobileMenu}>Explore curriculum</Link>
          <Link to="/roadmap" onClick={closeMobileMenu}>Public roadmap</Link>
        </div>
        <button className="nav__cta" onClick={handleJoinEarlyAccess}>Join early access</button>
      </div>
    </nav>
  );
};

export default Nav;
